export const ACTION_TYPES = {
    CLEAN_EVENT_LIST_ERROR: 'CLEAN_EVENT_LIST_ERROR',
    CLEAN_EVENT_LIST: 'CLEAN_EVENT_LIST',

    LOAD_EVENT_LIST_REQUEST: 'LOAD_EVENT_LIST_REQUEST',
    LOAD_EVENT_LIST_SUCCESS: 'LOAD_EVENT_LIST_SUCCESS',
    LOAD_EVENT_LIST_FAILURE: 'LOAD_EVENT_LIST_FAILURE'
};